var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.207782 2.50235L5.99828 8.29274C6.13209 8.42654 6.31049 8.5 6.50486 8.5C6.69531 8.5 6.87383 8.42654 7.00742 8.29274L12.7925 2.50784C12.9263 2.37393 13 2.19542 13 2.00496C13 1.81451 12.9264 1.63589 12.7925 1.50209L12.3665 1.07604C12.2327 0.942239 12.0541 0.868361 11.8636 0.868361C11.6732 0.868361 11.4946 0.942239 11.3607 1.07604L6.50285 5.93393L1.63958 1.07044C1.50577 0.936744 1.32726 0.862971 1.1367 0.862971C0.946244 0.862971 0.767838 0.936744 0.633927 1.07044L0.207782 1.4967C-0.0693407 1.77392 -0.0693407 2.22512 0.207782 2.50235Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDownIcon);
export default __webpack_public_path__ + "static/media/sortDownIcon.3a664d364cd7c7ccf55997ba7cded7a3.svg";
export { ForwardRef as ReactComponent };